import React from 'react';
import { useNavigate } from 'react-router-dom';

import { INavigationSection, NavigationLink, PathEnum } from './sidebar.type';
import { SidebarMobile } from './sidebar-mobile';
import { useViewport } from './hooks';
import { SidebarDesktop } from './sidebar-desktop';
import { BeforeInstallPromptEvent } from './before-install-prompt-event';

export function Sidebar({
  homePath,
  navigationSections,
  userName,
  userCompanyName,
  pwaInstallEvent,
}: {
  homePath: PathEnum;
  navigationSections: INavigationSection[];
  userName: string;
  userCompanyName: string;
  pwaInstallEvent: BeforeInstallPromptEvent | null;
}): JSX.Element {
  const navigate = useNavigate();
  const { isSmallerScreen } = useViewport();

  const handleNavigationLinkClicked = (navigationLink: NavigationLink) => {
    navigate(navigationLink.path);
  };

  const handleLogoutClicked = () => {
    navigate(PathEnum.PATH_LOGOUT);
  };

  const handleUserProfileClicked = () => {
    navigate(PathEnum.PATH_USER_SETTINGS);
  };

  const handleUserManagementClick = () => {
    navigate(PathEnum.PATH_USER_MANAGEMENT);
  };

  return isSmallerScreen ? (
    <SidebarMobile
      homePath={homePath}
      navigationSections={navigationSections}
      onLogoutClick={handleLogoutClicked}
      onNavigationLinkClick={handleNavigationLinkClicked}
      onUserProfileClick={handleUserProfileClicked}
      onUserManagementClick={handleUserManagementClick}
      userCompanyName={userCompanyName}
      userName={userName}
      pwaInstallEvent={pwaInstallEvent}
    />
  ) : (
    <SidebarDesktop
      homePath={homePath}
      navigationSections={navigationSections}
      onLogoutClick={handleLogoutClicked}
      onNavigationLinkClick={handleNavigationLinkClicked}
      onUserProfileClick={handleUserProfileClicked}
      onUserManagementClick={handleUserManagementClick}
      userCompanyName={userCompanyName}
      userName={userName}
      pwaInstallEvent={pwaInstallEvent}
    />
  );
}
